import { toast } from "react-toastify";

export function* sagaErrorHandler(error) {
  console.log(error, "error");
  if (!error) return
  if (error?.data){
    toast.error(error.data.message)
  }
}
